import * as THREE from "three";
import gsap from 'gsap'
import { displayDetails } from './clickDetails'

import vertexShader from '../shaders/vertex.glsl'
import fragmentShader from '../shaders/fragment.glsl'

// basics
const canvas = document.querySelector("canvas.webgl");

let updateImage = true

const mouse = new THREE.Vector2(0, 0);

// texture
const images = document.querySelectorAll(".tile__img");
const loader = new THREE.TextureLoader();
const imagesBasic = [];
const hoverImages = [];

for (let image of images) {
    imagesBasic.push(loader.load(image.src));
    hoverImages.push(loader.load(image.dataset.hover));
}

// scene
const scene = new THREE.Scene();

// camera
const perspective = 800;

const fov = (180 * (2 * Math.atan(window.innerHeight / 2 / perspective))) / Math.PI;
const camera = new THREE.PerspectiveCamera(fov, window.innerWidth / window.innerHeight, 1, 1000);
camera.position.set(0, 0, perspective);

// // plane
const sizes = []
const offsets = []


const getSizes = (i, image) => {
    const { width, height, top, left } = image.getBoundingClientRect();

    sizes[i].set(width, height);
    offsets[i].set(
        left - window.innerWidth / 2 + width / 2,
        -top + window.innerHeight / 2 - height / 2
    );
};

const getPositionSize = () => {

    for (let [i, image] of images.entries()) {
        sizes.push(new THREE.Vector2(0, 0))
        offsets.push(new THREE.Vector2(0, 0))
        getSizes(i, image);
    }
}
getPositionSize()



const geometry = new THREE.PlaneGeometry(1, 1);
const meshes = []
for (let [i, image] of images.entries()) {
    const uniforms = {
        u_image: { type: 't', value: imagesBasic[i] },
        u_imagehover: { type: 't', value: hoverImages[i] },
        u_mouse: { value: mouse },
        u_time: { value: 0 },
        u_res: { value: new THREE.Vector2(window.innerWidth, window.innerHeight) },
        u_alphaEffect: { value: 1 },
        u_alphaImage: { value: 1 },
        u_intensityEffect: { value: 0.025 },
    }
    const material = new THREE.ShaderMaterial({
        uniforms: uniforms,
        vertexShader: vertexShader,
        fragmentShader: fragmentShader,
        defines: {
            PR: window.devicePixelRatio.toFixed(1)
        },
        transparent: true
    })

    // const material = new THREE.MeshBasicMaterial()
    const mesh = new THREE.Mesh(geometry, material);
    mesh.position.set(offsets[i].x, offsets[i].y, 0);
    mesh.scale.set(sizes[i].x, sizes[i].y, 1);
    scene.add(mesh);
    meshes.push(mesh)
}

// renderer
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    alpha: true
});
renderer.setSize(window.innerWidth, window.innerHeight);
renderer.setPixelRatio(window.devicePixelRatio);
renderer.render(scene, camera);


// //animate

const tick = () => {
    requestAnimationFrame(tick);

    //update plane position
    for (let [i, mesh] of meshes.entries()) {
        getSizes(i, images[i])

        if (updateImage) {
            mesh.position.set(offsets[i].x, offsets[i].y, 0);
            mesh.scale.set(sizes[i].x, sizes[i].y, 1);
        }
        mesh.material.uniforms.u_time.value += 0.01
    }
    renderer.render(scene, camera);
};

tick()



// mouse

const onMouseMove = (event) => {
    gsap.to(mouse, {
        duration: 0.5,
        x: (event.clientX / window.innerWidth) * 2 - 1,
        y: -(event.clientY / window.innerHeight) * 2 + 1
    });
}


window.addEventListener("mousemove", (e) => {
    onMouseMove(e);
});



// click
const btnCloseDetails = document.getElementById('closeDetails')
const titles = document.querySelectorAll('.title')

const toggleDetails = (i, open) => {
    updateImage = false

    if (open) {
        meshes[i].material.uniforms.u_image.value = hoverImages[i]

        for (let index = 0; index < meshes.length; index++) {
            if (i !== index) {
                gsap.to(meshes[index].material.uniforms.u_alphaImage, { delay: 0.2, value: 0, duration: 0.4 })
            }
            meshes[index].material.uniforms.u_alphaEffect.value = 0;
        }
    } else {
        meshes[i].material.uniforms.u_image.value = imagesBasic[i]

        setTimeout(() => {
            for (let mesh of meshes) {
                gsap.to(mesh.material.uniforms.u_alphaImage, { delay: 0.4, value: 1, duration: 0.4 })
                mesh.material.uniforms.u_alphaEffect.value = 1;
            }
        }, 1000)
    }

    const newScl = {
        x: open ? window.innerWidth * 0.44 : sizes[i].x,
        y: open ? window.innerHeight - 140 : sizes[i].y,
    }

    const newPos = {
        x: open ? window.innerWidth / 2 - window.innerWidth * 0.05 - sizes[i].x * 0.95 : offsets[i].x,
        y: open ? -20 : offsets[i].y,
    }

    gsap.to(meshes[i].scale, { duration: 1.2, delay: 0.4, x: newScl.x, y: newScl.y, ease: 'power2.out' })
    gsap.to(meshes[i].position, { duration: 1.2, delay: 0.4, x: newPos.x, y: newPos.y, ease: 'power2.out' })

    setTimeout(() => {
        updateImage = !open
    }, 2000)
}

for (let [i, image] of images.entries()) {
    
    image.addEventListener('click', () => {
        if (updateImage) {
            displayDetails(i, true)
            toggleDetails(i, true)
        }
        });
        titles[i].addEventListener('click', () => {
            displayDetails(i, true)
            toggleDetails(i, true)
        });
}


btnCloseDetails.addEventListener('click', () => {
    for (let [i, image] of images.entries()) {
        displayDetails(i, false)
        toggleDetails(i, false)
    };
})


// resize
window.addEventListener("resize", () => {
	// Update camera
	camera.aspect = window.innerWidth/ window.innerHeight;
	camera.updateProjectionMatrix();

	// Update renderer
	renderer.setSize(window.innerWidth, window.innerHeight);
	renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    
    for (let [i, mesh] of meshes.entries()) {
        getSizes(i, images[i])

        if (updateImage) {
            mesh.position.set(offsets[i].x, offsets[i].y, 0);
            mesh.scale.set(sizes[i].x, sizes[i].y, 1);
            mesh.material.uniforms.u_res.value.set(window.innerWidth, window.innerHeight)
        }
    }
    renderer.render(scene, camera);
    
});